<template>
  <div class="asc-associated-analytic-grid">
    <asc-ag-grid-filter
      :key="`asc-associated-analytic-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
      :grid-size="getGridSize"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import { AscAgGridFilter } from '@/components/agGrid'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscAssociatedAnalyticsGrid',

  components: {
    AscAgGridFilter,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        headerHeight: 30,
        suppressNoRowsOverlay: true,
        rowSelection: 'single',
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
      }),
    }
  },

  computed: {
    getGridSize() {
      return this.agGridRowData.length >= 5 ? 'sm' : 'auto'
    },
    mappedValues() {
      return this.values
    },
    agGridRowData() {
      this.resetLocalStorage(this.localStorageName)
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: 'Analytic',
          field: 'analyticName',
        },
        {
          headerName: 'Analytic Display Name',
          field: 'analyticDisplayName',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-sort-icon {
  color: $primary_black;
  position: absolute;
  top: 14px;
  right: 16px;
}

.asc-filter-icon {
  color: $primary_black;
}
</style>
